// extracted by mini-css-extract-plugin
export default {"downloadBtns":"DownloadButtons_downloadBtns__95oIH"};